import { render, staticRenderFns } from "./FlightDetail.vue?vue&type=template&id=2f5e73b9&"
import script from "./FlightDetail.vue?vue&type=script&lang=js&"
export * from "./FlightDetail.vue?vue&type=script&lang=js&"
import style0 from "./FlightDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports